export default "__VITE_ASSET__Cs20B8UO__"